import {
  OrgSiteListEntry,
  SimplifiedSdmMatchConfig,
} from "@inrange/building-manager-api-client/models-organisation";
import { NetworkSite } from "@inrange/building-manager-api-client/models-site";
import "leaflet/dist/leaflet.css";
import React from "react";
import { fractionalCurrencySymbol } from "../../formatting/currency-utils";
import { formatUnitsToNearestTen } from "../../formatting/formatKiloUnits";
import displayId from "../../utils/displayId";
import "./map.css";
import {
  MARKETPLACE_COLOR_YELLOW,
  PopupSubHeading,
  PopupText,
  PopupTextHighlighted,
  PopupTextLine,
} from "./marketplace-map-styles";

const NetworkExploreExistingSellsMarker: React.FC<{
  site: NetworkSite;
  existingBuys: SimplifiedSdmMatchConfig[];
  orgSitesById: Record<string, OrgSiteListEntry>;
}> = ({ site, existingBuys, orgSitesById }) => {
  return (
    <div>
      <PopupText $fontWeight="0">
        InRange network site {displayId(site.id).substring(0, 3)}
      </PopupText>
      <PopupText $fontWeight="0" $fontSize="10px">
        {displayId(site.id)}
      </PopupText>
      <PopupSubHeading $color={MARKETPLACE_COLOR_YELLOW}>
        Buying from {existingBuys.length} of your sites
      </PopupSubHeading>
      {existingBuys.map((buy) => (
        <PopupTextLine key={buy.sellerId}>
          <PopupTextHighlighted>
            {formatUnitsToNearestTen(buy.volume, "kWh")}
          </PopupTextHighlighted>{" "}
          / year @{" "}
          <PopupTextHighlighted>
            {(buy.tariff * 100).toFixed(2)}
            {fractionalCurrencySymbol(site.currencyCode)} / kWh
          </PopupTextHighlighted>{" "}
          from{" "}
          <PopupTextHighlighted>
            {orgSitesById[buy.sellerId].name}
          </PopupTextHighlighted>
        </PopupTextLine>
      ))}
      <PopupSubHeading $color={MARKETPLACE_COLOR_YELLOW}>
        Remaining energy to buy
      </PopupSubHeading>
      <PopupTextLine>
        <PopupTextHighlighted>
          {formatUnitsToNearestTen(site.energyFlowAnnual.gridImport, "kWh")}
        </PopupTextHighlighted>{" "}
        / year
      </PopupTextLine>
      <PopupText
        $fontWeight="0"
        $fontSize="12px"
        style={{ marginTop: "1.33em" }}
      >
        * Location is approximate
      </PopupText>
    </div>
  );
};

export default NetworkExploreExistingSellsMarker;
